// import { storeStructure } from '../store/reducers';
import tableLiveDeployment from './tableLiveDeploymentItems';
export default {
  title: 'Live Deployments',
  attributeName: "liveDeployments",
  getURL: 'livedeployments',
  createURL: 'livedeployments',
  updateURL: 'livedeploymentsmultiple',
  updateRowURL:'livedeploymentSingle',
  removeURL: 'livedeployments',
  removeReconfirmMessage:'Are you sure you want to delete this deployments and it´s lives and templates listed below?',
  removeReconfirmURL:'listlivesdeployment',
  sessionParams: [],
  websocketEventChanel:"liveDeployment",
  websocketItem: 'liveDeployment',
  noArea: true,
  tableConfig: tableLiveDeployment,
  autoUpdate: true,
};